const apiUrl =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production"
    ? "https://api.intranet.ethik-gestion.fr/api"
    : "http://localhost:5000/api");

export default apiUrl;